import React, { useContext, useEffect, useState } from "react";
import { MenuBarContext } from "../../contexts/MenuBarContext";
import {
  IoArrowForwardCircleOutline,
  IoArrowBackCircleOutline,
} from "react-icons/io5";
import { navbarContent } from "../../data/Data";
import { SlMinus } from "react-icons/sl";
import { GoPlusCircle } from "react-icons/go";
import { useNavigate } from "react-router-dom";

const MenuBar = () => {
  const navigate = useNavigate();
  const { isMenuOpen, toggleMenu, closeMenu } = useContext(MenuBarContext);
  const [isOpen, setOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);

  const handleActiveKey = (key) => {
    console.log(key);
    if (activeMenu == key && isOpen) {
      setOpen(false);
    } else {
      setOpen(true);
      setActiveMenu(key);
    }
  };

  const handleSubMenu = (key) => {
    // Toggle the specific submenu open/close
    console.log(key);
    setActiveSubMenu((prevKey) => (prevKey === key ? null : key));
  };

  // useEffect(() => {
  //   if (isMenuOpen) {
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     document.body.style.overflow = "auto";
  //   }

  //   return () => {
  //     document.body.style.overflow = "auto";
  //   };
  // }, [isMenuOpen]);

  return (
    <div className="md:hidden block font-basefont z-70  ">
      <div
        className={`fixed top-16 z-50 w-full bg-white  text-basecolor h-full transition-transform duration-500 ease-in-out transform ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* <ul className="p-4 space-y-6 flex flex-col text-lg w-full items-start">
          {menuItems?.map((item, index) => (
            <li
              key={index}
              className="hover:text-gray-300 borer w-full flex border-b border-gray-300  text-black"
              onClick={() => {
                if (item?.subMenu) {
                  handleActiveKey(item.key);
                } else {
                  navigate({
                    pathname: `${process.env.PUBLIC_URL}${item?.path}`,
                  });
                }
              }}
            >
              <p className="block w-full p-2 flex justify-between">
                {item.name}{" "}
                {item?.subMenu && (
                  <span className="text-lg">
                    {activeMenu == item.key && isOpen ? (
                      <SlMinus className="h-6 w-6" />
                    ) : (
                      <GoPlusCircle className="h-6 w-6" />
                    )}
                  </span>
                )}
                <span className="h-6 w-6 flex items-center">{item.icon}</span>
              </p>
              {isOpen && activeMenu == "services" && (
                <div
                  className={`fixed top-16 right-0 w-full white text-basecolor min-h-screen transition-transform duration-500 ease-in-out transform ${
                    isMenuOpen ? "translate-x-0" : "translate-x-full"
                  } overflow-y-auto`}
                >
                  <button
                    className="text-black flex items-center space-x-2 px-4 py-3"
                    onClick={() => setOpen(false)}
                  >
                    <IoArrowBackCircleOutline className="h-6 w-6" />{" "}
                    <span>Back</span>
                  </button>

                  <ul className="p-4 space-y-6 flex flex-col text-lg w-full p-4 w-full overflow-y-auto">
                    {navbarContent?.map((item, index) => (
                      <li
                        key={index}
                        className=" border-b w-full border-gray-300 w-full text-black"
                      >
                        <p
                          onClick={() => handleSubMenu(item.key)}
                          className="cursor-pointer block py-3 flex justify-between w-full"
                        >
                          {item.title}{" "}
                        </p>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          ))}
        </ul> */}
        <ul className="p-4 space-y-6 flex flex-col text-lg w-full items-start overflow-y-auto h-full">
          {menuItems?.map((item, index) => (
            <li
              key={index}
              // className="hover:text-gray-300 border w-full flex flex-col border-b border-gray-300 text-black"
              className="hover:text-gray-300 borer w-full flex flex-col border-b border-gray-300  text-black cursor-pointer"
              onClick={() => {
                if (item?.subMenu) {
                  handleActiveKey(item.key);
                } else {
                  navigate({
                    pathname: `${process.env.PUBLIC_URL}${item?.path}`,
                  });
                  closeMenu();
                }
              }}
            >
              <div className="block w-full p-2 mb-3 flex justify-between items-center">
                {item.name}
                <div className="flex items-center space-x-4">
                  {item?.subMenu && (
                    <span className="text-lg">
                      {activeMenu == item.key && isOpen ? (
                        <SlMinus className="h-6 w-6" />
                      ) : (
                        <GoPlusCircle className="h-6 w-6" />
                      )}
                    </span>
                  )}
                  <span className="h-6 w-6 flex items-center">{item.icon}</span>
                </div>
              </div>

              {/* Render submenu inline under the current item */}
              {isOpen && activeMenu == item.key && (
                <ul className="pl-4 pb-2 space-y-4 text-sm text-black">
                  {navbarContent?.map((sub, subIndex) => (
                    <li
                      key={subIndex}
                      // onClick={() => handleSubMenu(sub.key)}
                      className="cursor-pointer hover:underline"
                      onClick={() => {
                        navigate({
                          pathname: `${process.env.PUBLIC_URL}${sub?.url}`,
                        });
                        closeMenu();
                      }}
                    >
                      {sub.title}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
    // <div className="md:hidden block fixed inset-0 z-[9999] font-basefont">
    //   {/* Main Mobile Menu */}
    //   <div
    //    className={`absolute top-16 right-0 w-full bg-white text-basecolor h-full transition-transform duration-500 ease-in-out transform ${
    //   isMenuOpen ? "translate-x-0" : "translate-x-full"
    // }`}
    //   >
    //     <ul className="p-4 space-y-6 flex flex-col text-lg w-full items-start">
    //       {menuItems?.map((item, index) => (
    //         <li
    //           key={index}
    //           className="hover:text-gray-300 w-full flex border-b border-gray-300 text-black"
    //           onClick={() => handleActiveKey(item.key)}
    //         >
    //           <a
    //             className="block w-full p-2 flex justify-between"
    //             href={item.path}
    //           >
    //             {item.name}
    //             <span className="h-6 w-6 flex items-center">{item.icon}</span>
    //           </a>
    //         </li>
    //       ))}
    //     </ul>
    //   </div>

    //   {/* Services Submenu */}
    //   {isOpen && activeMenu === "services" && (
    //     <div
    //       className={`fixed inset-0 bg-white text-basecolor transition-transform duration-500 ease-in-out transform ${isMenuOpen ? "translate-x-0" : "translate-x-full"
    //         } overflow-y-auto z-[9999]`}
    //     >
    //       <button
    //         className="text-black flex items-center space-x-2 px-4 py-3"
    //         onClick={() => setOpen(false)}
    //       >
    //         <IoArrowBackCircleOutline className="h-6 w-6" />
    //         <span>Back</span>
    //       </button>

    //       <ul className="p-4 space-y-6 flex flex-col text-lg w-full">
    //         {navbarContent?.map((item, index) => (
    //           <li
    //             key={index}
    //             className="border-b w-full border-gray-300 text-black"
    //           >
    //             <a
    //               href={item.url}
    //               className="cursor-pointer block py-3 flex justify-between w-full"
    //             >
    //               <span className="text-lg">{item.title}</span>
    //             </a>

    //             {activeSubMenu === item.key && (
    //               <div className="p-4 w-full">
    //                 <span className="text-lg mb-5 w-full flex items-start text-left">
    //                   {item.description}
    //                 </span>
    //                 <ul>
    //                   {item?.submenus?.map((submenu, idx) => (
    //                     <li
    //                       key={idx}
    //                       className="flex items-center space-x-3 py-3"
    //                     >
    //                       <p className="cursor-pointer flex justify-between items-center text-basecolor space-x-4">
    //                         <IoArrowForwardCircleOutline className="h-6 w-6" />
    //                         <span>{submenu?.title}</span>
    //                       </p>
    //                     </li>
    //                   ))}
    //                 </ul>
    //               </div>
    //             )}
    //           </li>
    //         ))}
    //       </ul>
    //     </div>
    //   )}
    // </div>
  );
};

const menuItems = [
  {
    name: "Home",
    path: "home",
  },
  {
    name: "Our Services",
    // icon: (
    //   <span>
    //     <IoArrowForwardCircleOutline className="h-6 w-6" />
    //   </span>
    // ),
    key: "services",
    subMenu: true,
  },
  {
    name: "About us",
    path: "about",
  },
  {
    name: "Testimonals",
    path: "testimonials",
  },
 
  {
    name: "Contact",
    path: "contact",
  },
];

export default MenuBar;
